import type { EditorThemeClasses } from 'lexical';

import './PlaygroundEditorTheme.css';

const theme: EditorThemeClasses = {
  autocomplete: 'RTEditor__autocomplete',
  blockCursor: 'RTEditor__blockCursor',
  characterLimit: 'RTEditor__characterLimit',
  code: 'RTEditor__code',
  codeHighlight: {
    'atrule': 'RTEditor__tokenAttr',
    'attr': 'RTEditor__tokenAttr',
    'boolean': 'RTEditor__tokenProperty',
    'builtin': 'RTEditor__tokenSelector',
    'cdata': 'RTEditor__tokenComment',
    'char': 'RTEditor__tokenSelector',
    'class': 'RTEditor__tokenFunction',
    'class-name': 'RTEditor__tokenFunction',
    'comment': 'RTEditor__tokenComment',
    'constant': 'RTEditor__tokenProperty',
    'deleted': 'RTEditor__tokenProperty',
    'doctype': 'RTEditor__tokenComment',
    'entity': 'RTEditor__tokenOperator',
    'function': 'RTEditor__tokenFunction',
    'important': 'RTEditor__tokenVariable',
    'inserted': 'RTEditor__tokenSelector',
    'keyword': 'RTEditor__tokenAttr',
    'namespace': 'RTEditor__tokenVariable',
    'number': 'RTEditor__tokenProperty',
    'operator': 'RTEditor__tokenOperator',
    'prolog': 'RTEditor__tokenComment',
    'property': 'RTEditor__tokenProperty',
    'punctuation': 'RTEditor__tokenPunctuation',
    'regex': 'RTEditor__tokenVariable',
    'selector': 'RTEditor__tokenSelector',
    'string': 'RTEditor__tokenSelector',
    'symbol': 'RTEditor__tokenProperty',
    'tag': 'RTEditor__tokenProperty',
    'url': 'RTEditor__tokenOperator',
    'variable': 'RTEditor__tokenVariable',
  },
  embedBlock: {
    base: 'RTEditor__embedBlock',
    focus: 'RTEditor__embedBlockFocus',
  },
  hashtag: 'RTEditor__hashtag',
  heading: {
    h1: 'RTEditor__h1',
    h2: 'RTEditor__h2',
    h3: 'RTEditor__h3',
    h4: 'RTEditor__h4',
    h5: 'RTEditor__h5',
    h6: 'RTEditor__h6',
  },
  hr: 'RTEditor__hr',
  hrSelected: 'RTEditor__hrSelected',
  image: 'editor-image',
  indent: 'RTEditor__indent',
  inlineImage: 'inline-editor-image',
  layoutContainer: 'RTEditor__layoutContainer',
  layoutItem: 'RTEditor__layoutItem',
  link: 'RTEditor__link',
  list: {
    checklist: 'RTEditor__checklist',
    listitem: 'RTEditor__listItem',
    listitemChecked: 'RTEditor__listItemChecked',
    listitemUnchecked: 'RTEditor__listItemUnchecked',
    nested: {
      listitem: 'RTEditor__nestedListItem',
    },
    olDepth: ['RTEditor__ol1', 'RTEditor__ol2', 'RTEditor__ol3', 'RTEditor__ol4', 'RTEditor__ol5'],
    ul: 'RTEditor__ul',
  },
  ltr: 'RTEditor__ltr',
  mark: 'RTEditor__mark',
  markOverlap: 'RTEditor__markOverlap',
  paragraph: 'RTEditor__paragraph',
  quote: 'RTEditor__quote',
  rtl: 'RTEditor__rtl',
  specialText: 'RTEditor__specialText',
  tab: 'RTEditor__tabNode',
  table: 'RTEditor__table',
  tableAddColumns: 'RTEditor__tableAddColumns',
  tableAddRows: 'RTEditor__tableAddRows',
  tableAlignment: {
    center: 'RTEditor__tableAlignmentCenter',
    right: 'RTEditor__tableAlignmentRight',
  },
  tableCell: 'RTEditor__tableCell',
  tableCellActionButton: 'RTEditor__tableCellActionButton',
  tableCellActionButtonContainer: 'RTEditor__tableCellActionButtonContainer',
  tableCellHeader: 'RTEditor__tableCellHeader',
  tableCellResizer: 'RTEditor__tableCellResizer',
  tableCellSelected: 'RTEditor__tableCellSelected',
  tableFrozenColumn: 'RTEditor__tableFrozenColumn',
  tableFrozenRow: 'RTEditor__tableFrozenRow',
  tableRowStriping: 'RTEditor__tableRowStriping',
  tableScrollableWrapper: 'RTEditor__tableScrollableWrapper',
  tableSelected: 'RTEditor__tableSelected',
  tableSelection: 'RTEditor__tableSelection',
  text: {
    bold: 'RTEditor__textBold',
    capitalize: 'RTEditor__textCapitalize',
    code: 'RTEditor__textCode',
    highlight: 'RTEditor__textHighlight',
    italic: 'RTEditor__textItalic',
    lowercase: 'RTEditor__textLowercase',
    strikethrough: 'RTEditor__textStrikethrough',
    subscript: 'RTEditor__textSubscript',
    superscript: 'RTEditor__textSuperscript',
    underline: 'RTEditor__textUnderline',
    underlineStrikethrough: 'RTEditor__textUnderlineStrikethrough',
    uppercase: 'RTEditor__textUppercase',
  },
};

export default theme;
